module.exports = {"language":{"flags":{"contribute_translations":"Contribute translations"}}};